<script>
import { BACKEND_HTTP_PATH } from 'src/config';

const validThemeList = ['light', 'dark', 'transparent', 'bot'];
const validTypeList = ['operator', 'anon', 'client', 'web', 'vk', 'facebook',
  'email', 'telegram', 'viber', 'whatsapp', 'voice'];
const validSizeList = ['small', 'normal', 'large'];

export default {
  data() {
    return {
      BACKEND_HTTP_PATH,
    };
  },
  props: {
    theme: {
      type: String,
      default: 'light',
      validator(value) {
        return validThemeList.includes(value);
      },
    },
    type: {
      type: String,
      default: 'client',
      validator(value) {
        return validTypeList.includes(value);
      },
    },
    size: {
      type: String,
      default: 'normal',
      validator(value) {
        return validSizeList.includes(value);
      },
    },
    src: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    key() {
      return `${this.type}${this.theme}`;
    },
    urlAvatar() {
      return this.src.replace(/^\//, BACKEND_HTTP_PATH);
    },
  },
};
</script>

<template lang="pug">
div(:class="[$style.root, $style[size], $style[theme]]", :key="key")
  ui-icon(:class="$style.ico") user-{{ type === 'web' ? 'client' : type }}-{{ theme }}
  figure(
    v-if="src && (type === 'client' || type === 'operator')",
    :class="$style.pic",
    :style="{ backgroundImage: `url(${urlAvatar})`}")
</template>

<style module lang="sass">
.root
  overflow: hidden
  border-radius: 50%
  position: relative
  display: inline-block
.pic
  height: 100%
  width: 100%
  border-radius: 50%
  border: 1px solid $color_text_second_dark
  background-size: cover
  background-repeat: no-repeat
  position: relative
  z-index: 2
.small
  width: 30px
  height: 30px
.normal
  width: 40px
  height: 40px
.large
  height: 60px
  width: 60px
.light
  color: $color_bg_light_accent
  background: $color_bg_light
.dark
  color: $white
.transparent
  color: $white
  background: $color_red
.ico
  height: 100%
  width: 100%
  display: block
  position: absolute
  top: 0
  z-index: 1

</style>
